import {useTranslation} from "react-i18next";
import GridPanel from "./GridPanel";
import {MutableRefObject, useState} from "react";
import {useIsBiggerThanSize, useIsSmallerThanSize} from "../../sizes/sizes";

type Props = {
    myProjectsRef: MutableRefObject<any>
    studiesRef: MutableRefObject<any>
    workExperienceRef: MutableRefObject<any>
    otherDataRef: MutableRefObject<any>
    stackRef: MutableRefObject<any>
    skillsRef: MutableRefObject<any>
}

const NewGrid = (props: Props) => {
    const {t} = useTranslation();
    const [hoverCell, setHoverCell] = useState<number>(-1)
    const setActCell = (n: number) => setHoverCell(n)
    const isMobile = useIsSmallerThanSize('sm')
    const isDesktop = useIsBiggerThanSize('lg')

    const scrollTo = (ref: MutableRefObject<any>) =>
        ref.current.scrollIntoView({behavior: "smooth", block: "start"})

    const label = (title: string) =>
        <div className={"absolute inset-0 flex items-end p-4"}>
            <div className={"border-l-2 border-accent pl-3"}>
                <p className={"text-base font-semibold text-white lg:text-lg"}>{title}</p>
            </div>
        </div>

    return (
        <div
            className={"select-none grid w-full gap-2 sm:gap-4 grid-cols-[1fr_1fr] sm:grid-cols-3 lg:grid-cols-9"}>
            <GridPanel background={"/img/workI.png"}
                fadeDir={isDesktop ? "fade-down" : "fade-right"}
                onClick={() => {scrollTo(props.workExperienceRef)}}
                       id="Experiencia laboral" cellNum={1} hoverCell={hoverCell} setHoverCell={setActCell}
                       className={"col-start-1 col-end-2 row-start-1 sm:col-start-1 sm:col-end-2 " +
                           "sm:row-start-1 lg:col-start-1 lg:col-end-6 lg:row-start-1 min-h-[88px]"}>
                {label(t("workExperience.title"))}
            </GridPanel>
            <GridPanel background={"/img/codeProjects.png"}
                fadeDir={isDesktop ? "fade-right" : (isMobile ? "fade-left" : "fade-down")}
                onClick={() => {scrollTo(props.myProjectsRef)}}
                       id={"Proyectos"} cellNum={2} hoverCell={hoverCell} setHoverCell={setActCell}
                       className={"col-start-2 col-end-3 row-start-1 sm:col-start-2 sm:col-end-3 " +
                           "sm:row-start-1 lg:col-start-1 lg:col-end-6 lg:row-start-2 min-h-[88px]"}>
                {label(t("projects.title"))}
            </GridPanel>
            <GridPanel background={"/img/tech.png"}
                fadeDir={isDesktop ? "fade-down-left" : (isMobile ? "fade-right" : "fade-left")}
                onClick={() => {scrollTo(props.stackRef)}}
                       id={"Tecnologias"} cellNum={3} hoverCell={hoverCell} setHoverCell={setActCell}
                       className={"col-start-1 col-end-2 row-start-2 sm:col-start-3 sm:col-end-4 " +
                           "sm:row-start-1 lg:col-start-8 lg:col-end-10 lg:row-start-1 min-h-[88px]"}>
                {label(t("stack.title"))}
            </GridPanel>
            <GridPanel background={"/img/skills.png"}
                fadeDir={isDesktop ? "fade-down" : (isMobile ? "fade-left" : "fade-right")}
                       onClick={() => {scrollTo(props.skillsRef)}}
                       id="Conocimientos" cellNum={4} hoverCell={hoverCell} setHoverCell={setActCell}
                       className={"col-start-2 col-end-3 row-start-2 sm:col-start-1 sm:col-end-2 " +
                           "sm:row-start-2 lg:col-start-6 lg:col-end-8 lg:row-start-1 min-h-[88px]"}>
                {label(t("skills.title"))}
            </GridPanel>
            <GridPanel background={"/img/studies.png"}
                fadeDir={isDesktop ? "fade-right" : (isMobile ? "fade-right" : "fade-down")}
                onClick={() => {scrollTo(props.studiesRef)}}
                       id={"Estudios"} cellNum={5} hoverCell={hoverCell} setHoverCell={setActCell}
                       className={"col-start-1 col-end-2 row-start-3 sm:col-start-2 sm:col-end-3 " +
                           "sm:row-start-2 lg:col-start-6 lg:col-end-8 lg:row-start-2 min-h-[88px]"}>
                {label(t("studies.title"))}
            </GridPanel>
            <GridPanel background={"/img/otherData.png"}
                fadeDir={"fade-left"}
                onClick={() => {scrollTo(props.otherDataRef)}}
                       id={"Otros datos"} cellNum={6} hoverCell={hoverCell} setHoverCell={setActCell}
                       className={"col-start-2 col-end-3 row-start-3 sm:col-start-3 sm:col-end-4 " +
                           "sm:row-start-2 lg:col-start-8 lg:col-end-10 lg:row-start-2 min-h-[88px]"}>
                {label(t("otherData.title"))}
            </GridPanel>
        </div>
    )
}

export default NewGrid
